<script>
import HonorCalculationTable from "./HonorCalculationTable.vue";

export default {
  components: {
    HonorCalculationTable,
  },
  data() {
    return {
      columns: [
        { width: "50px", label: "No", name: "id" },
        // { width: "200px", label: "Dahan Profesi", name: "dahan_profesi" },
        { width: "200px", label: "Kompetensi", name: "kompetensi" },
        { width: "200px", label: "Nama", name: "nama" },
        { width: "140px", label: "NIP", name: "nip" },
        { width: "140px", label: "Jumlah Paket", name: "jumlah_paket" },
        { width: "100px", label: "Level", name: "level" },
        { width: "140px", label: "Honor per Paket", name: "honor_per_paket" },
        { width: "140px", label: "Realisasi Paket", name: "realisasi_paket" },
        { width: "140px", label: "Jumlah Honor", name: "jumlah_honor" },
        { width: "140px", label: "Bruto", name: "bruto" },
        { width: "140px", label: "DPP", name: "dpp" },
        { width: "160px", label: "PPh Ps.21", name: "pph" },
        { width: "180px", label: "Yang Dibayarkan", name: "dibayarkan" },
      ],
    };
  },
};
</script>

<template>
  <HonorCalculationTable
    api-url="verifikasi/perhitungan-honor/penyusun-soal"
    add-form-config-api-url="verifikasi/konfig-honor/penyusun-soal"
    konfig-honor-jenis="penyusun"
    :columns="columns"
    tab-title="Perhitungan Honor Penyusun Soal"
    tab-subtitle="Kelola perhitungan honor penyusun soal berdasarkan kompetensi, paket, dan realisasi."
    excel-file-name="perhitungan-honor-penyusun-soal.xlsx"
    excel-sheet-name="Honor Penyusun Soal"
    summary-main-label="Total Penyusun Soal"
    :use-status-filter="false"
    :use-ba-filter="false"
    :require-ba-for-calculation="false"
    :use-penyusun-soal-selects="true"
  />
</template>
